import {
  Address,
  Cart,
  CartModification,
  UserEnum,
  DeliveryMode,
  Order,
  PaymentDetails,
  GroupOrderModification,
  EntryGroup,
  EntryGroupUpdate,
} from '@boels/models';
import { createAction, props } from '@ngrx/store';

export const getCart = createAction('[Cart] Get Cart');

export const loadCart = createAction('[Cart] Load Cart');

export const createCart = createAction('[Cart] Create Cart');

export const loadCartSuccess = createAction(
  '[Cart] Load Cart Success',
  props<{ cart: Cart; cartId: string }>(),
);

export const loadCartFailure = createAction(
  '[Cart] Load Cart Failure',
  props<{ errorMessage: string }>(),
);

export const createCartSuccess = createAction(
  '[Cart] Create Cart Success',
  props<{ cart: Cart; cartId: string }>(),
);

export const createCartFailure = createAction(
  '[Cart] Create Cart Failure',
  props<{ errorMessage: string }>(),
);

export const addToCart = createAction(
  '[Cart] Add to Cart',
  props<EntryGroup>(),
);

export const addToCartSuccess = createAction(
  '[Cart] Add to Cart Success',
  props<{ cartModifications: GroupOrderModification }>(),
);

export const addToCartFailure = createAction(
  '[Cart] Add to Cart Failure',
  props<{ errorMessage: string }>(),
);

export const removeFromCart = createAction(
  '[Cart] Remove from Cart',
  props<{ entryNumber: number }>(),
);

export const removeFromCartSuccess = createAction(
  '[Cart] Remove from Cart Success',
  props<{ cart: Cart }>(),
);

export const removeFromCartFailure = createAction(
  '[Cart] Remove from Cart Failure',
  props<{ errorMessage: string }>(),
);

export const updateCart = createAction(
  '[Cart] Update Cart',
  props<EntryGroupUpdate>(),
);

export const updateCartSuccess = createAction(
  '[Cart] Update Cart Success',
  props<{ cartModifications: GroupOrderModification }>(),
);

export const updateCartFailure = createAction(
  '[Cart] Update Cart Failure',
  props<{ errorMessage: string }>(),
);

export const removeCart = createAction(
  '[Cart] Remove Cart',
  props<{ cartId: string }>(),
);

export const setActiveCart = createAction(
  '[Cart] Set Active Cart',
  props<{ activeCartId: string }>(),
);

export const setCheckoutStepNumber = createAction(
  '[Cart] Set Checkout Step Number',
  props<{ checkoutStepNumber: number }>(),
);

export const updateCartMode = createAction(
  '[Cart] update Cart Point of Service',
  props<{
    pointOfServiceName: string;
    useRentalWall: boolean;
  }>(),
);

export const updateCartModeSuccess = createAction(
  '[Cart] update Cart Point of Service Success',
  props<{ cartModifications: CartModification }>(),
);

export const updateCartModeFailure = createAction(
  '[Cart] update Cart Point of Service Failure',
  props<{ errorMessage: string }>(),
);

export const placeOrderChallenge = createAction(
  '[Checkout] Place Order Challenge',
  props<{ termsChecked: boolean; remarks?: string; newsletter?: boolean }>(),
);

export const placeOrderRecaptcha = createAction(
  '[Checkout] Place Order with RecaptchaToken',
  props<{
    termsChecked: boolean;
    recaptchaToken: string;
    newsletter?: boolean;
  }>(),
);

export const placeOrderFail = createAction(
  '[Checkout] Place Order Fail',
  props<{ error: any }>(),
);

export const placeOrderSuccess = createAction(
  '[Checkout] Place Order Success',
  props<{ order: Order; newsletter?: boolean }>(),
);

export const setDeliveryAddress = createAction(
  '[Checkout] Set delivery address',
  props<{ deliveryAddress: Address | undefined }>(),
);

export const setDeliveryMode = createAction(
  '[Checkout] Set delivery mode',
  props<{ deliveryMode: DeliveryMode | undefined }>(),
);

export const updateCartDates = createAction(
  '[Checkout] Set hire period',
  props<{ startDate: string | undefined; endDate: string | undefined }>(),
);

export const updateCartDatesSuccess = createAction(
  '[Checkout] Update Cart Dates success',
  props<{ startDate: string | undefined; endDate: string | undefined }>(),
);

export const setPaymentInfo = createAction(
  '[Checkout] Update PaymentInfo',
  props<{ paymentDetails: PaymentDetails | undefined }>(),
);

export const setCheckoutAccount = createAction(
  '[Checkout] Set Checkout Account',
  props<{ checkoutAccount: UserEnum }>(),
);
